const status = ['ALL', 'AVAILABLE', 'MOVING_OUT', 'OVERDUE_MOVEOUT', 'MOVEOUT_RESERVED', 'RENTED', 'PENDING', 'RESERVED', 'UNAVAILABLE'];

export default status;

export const leaseStatuses = [
  'ALL',
  'AUCTION',
  'CURRENT',
  'LATE',
  'LIEN',
  'PRE_LIEN',
];

export const paymentStatuses = [
  { label: 'All', value: 'All' },
  { label: 'Initiated', value: 'initiated' },
  { label: 'Completed', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'Pending', value: 'pending' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Voided', value: 'voided' },
  { label: 'Disputed', value: 'disputed' },
  { label: 'Declined', value: 'declined' },
];

export const stillfullApplicableStatuses = [
  'MOVING_OUT',
  'OVERDUE_MOVEOUT',
  'MOVEOUT_RESERVED',
  'RENTED',
];



// WEBPACK FOOTER //
// ./src/utils/status.js